import Mkubacktop from './src/backtop';

Mkubacktop.install = function (Vue) {
  Vue.component(Mkubacktop.name, Mkubacktop);
};

export default Mkubacktop;
